import React, { Component } from "react";
import lstModules from 'common/json/lstModules.json';
import $ from "jquery";
import "jquery-ui";

import "common/css/master.css";
import "./hpc.css";
import axios from "axios";
import Header from "common/js/header/header.js";
import { toast, ToastContainer } from "react-toastify";
import Section from './section';
import HpcStudentTable from './hpcStudentTable.js';
import HpcStudentSlider from './hpcStudentSlider.js'
import { getHpcListSvc } from "./hpcStudentSvc";
var httpURLCommon = '', httpURL = "";
var queryString = require("querystring");
var screenId = 11;


const student = {
    schoolInfo: {
        school: "Sunrise Public School",
        address: "123 Elm Street",
        pin: "560001",
        UDISE: "123456789",
        APAARID: "APAARI001",
        teacherCode: "TCH001",
    },
    partA1: {
        studentId: "S001",
        generalInfo: {
            student: 'studentName',
            rollNo: "123",
            enrollmentNo: "ENR123",
            cls: "10",
            section: "A",
            dob: "2005-05-15",
            age: 10,
            address: "456 Maple Avenue",
            phone: "9876543210",
            photo: "path/to/photo.jpg",
            motherInfo: {
                parentId: "P001",
                parent: "Jane Doe",
                education: "Graduate",
                occupation: "Teacher",
            },
            fatherInfo: {
                parentId: "P002",
                parent: "John Sr.",
                education: "Postgraduate",
                occupation: "Engineer",
            },
            guardianInfo: {
                parentId: "P003",
                parent: "Uncle Sam",
                education: "High School",
                occupation: "Farmer",
            },
            noOfSiblings: 2,
            siblingsAge: [8, 12],
            motherTongue: "English",
            instructionMedium: "English",
            flgRuralUrban: "Urban",
        },
        attendanceInfo: {
            lstAttendance: [
                { monthId: 1, month: "Apr", workingDays: 22, daysAttended: 20, pctAttendance: "90%" },
                { monthId: 2, month: "May", workingDays: 20, daysAttended: 18, pctAttendance: "90%" },
                { monthId: 3, month: "Jun", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 4, month: "Jul", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 5, month: "Aug", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 6, month: "Sep", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 7, month: "Oct", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 8, month: "Nov", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 9, month: "Dec", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 10, month: "Jan", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 11, month: "Feb", workingDays: "", daysAttended: "", pctAttendance: "" },
                { monthId: 12, month: "Mar", workingDays: "", daysAttended: "", pctAttendance: "" },
            ],
            lowAttendanceReason: "Medical reasons",
        },
        lstInterest: [
            { interestId: 1, interest: "Reading", interested: true },
            { interestId: 2, interest: "Dancing or Singing", interested: false },
            { interestId: 3, interest: "Playing a musical instrument", interested: false },
            { interestId: 4, interest: "Sports or Games", interested: false },
            { interestId: 5, interest: "Creative writing", interested: false },
            { interestId: 6, interest: "Gardening", interested: false },
            { interestId: 7, interest: "Yoga", interested: false },
            { interestId: 8, interest: "Art", interested: false },
            { interestId: 9, interest: "Craft", interested: false },
            { interestId: 10, interest: "Cooking", interested: false },
            {
                interestId: 11,
                interest: "Regular chores at home with significant others (father, mother, guardian, sibling, etc.)",
                interested: false,
            }
        ],
    },
    partA2: {
        photoFamily: "path/to/family_photo.jpg",
        lstFriend: ["Alice", "Bob", "Charlie"],
        wantToBe: "Scientist",
        myFavourite: {
            color: "Blue",
            flower: "Rose",
            food: "Pizza",
            sport: "Cricket",
            animal: "Dog",
            subject: "Math",
        },
    },
    partB: {
        lstDomain: [
            {
                domainId: "D001",
                domain: "Physical Development",
                domainDesc: "Understanding advanced math concepts",
                lstGoals: ["Children develop habits that keep them healthy and safe."
                    , "Children develop sharpness in sensorial perceptions."
                    , "Children develop a fit and flexible body."],
                lstQuestion: [{ goal: "Learn algebra" }, { goal: "Master geometry" }],
                competency: "High",
                activityId: "A001",
                activity: "Solve equations",
                activityImg: "https://sms.cooledsys.com/sport.png",
                lstAssessmentQuestion: ["Solve for x", "Find the angle"],
                assessmentRubric: { a: 10, s: 20, c: 30 },
                observationalNotes: "Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills. Excellent problem solving skills.",
                studentSelfAssessment: {
                    like: 10,
                    easy: 20,
                    lstNeeded: [true, false, true, true, false],
                },
                peerAssessmentReceived: {
                    like: "Yes",
                    easy: "No",
                    lstNeeded: [true, false, true, true, false],
                },
                peerAssessmentGiven: {
                    like: "Yes",
                    easy: "No",
                    lstNeeded: [true, false, true, true, false],
                },
                parentObservation: {
                    lstAvailable: [true, false, true, true, false],
                    comment: "Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home. Needs more practice at home.",
                },
            },
        ],
    },
    partC: {
        lstPerformanceDescriptor: [
            {
                domainId: "D001",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
            {
                domainId: "D002",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
            {
                domainId: "D003",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
            {
                domainId: "D004",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
            {
                domainId: "D005",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
            {
                domainId: "D006",
                domain: "Physical Development",
                general: "Great improvement. Great improvement. Great improvement. Great improvement. Great improvement. Great improvement"
            },
        ],
    },
};

class HpcStudent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lstClass: [],
            tokenid: localStorage.getItem("tokenid"),
            wingId: localStorage.getItem("wingId"),
            lstFeeHead: [],
            discount: false,
            feeDiscount: [],
            feeHeadData: {},
            studentId: 0,
            feeHeadId: 0,
            feeClassId: 0,
            feeStudentId: 0,
            lstClassSection: [],
            classId: "",
            lstFeeStudent: [],
            lstStudentId: [],
            lstStudentPdf: [],
            basePathStudent: '',
            basePathActivity: '',
            sliderKey: 0,
            classSectionId: 0
        };
        this.changeCls = this.changeCls.bind(this);
        // this.sendFeebook = this.sendFeebook.bind(this);
    }
    setLstStudentId = (pLstStudentId) => {
        // console.log(pLstStudentId)
        this.setState({ lstStudentId: pLstStudentId })
    }
    componentDidMount() {
        // this.getFeeStudentsList();
        this.getLstClass();
    }


    getLstClass = () => {
        let wingId = this.state.wingId;
        this.setState({ loader: 'block', opacity: 0.5 });
        axios.post(httpURLCommon + '/sms/hpc/mst/cls_list',
            queryString.stringify({ wingId, screenId }), 
            {
                headers: { 'tokenid': this.state.tokenid },
                withCredentials: true,
            }).then(async (response) => {
                if (response.data.SvcStatus === 'Success') {
                    // console.log("response.data.lstWingClass = "+response.data.lstWingClass);
                    await this.setState({ lstClass: response.data.lstCls });
                } else {
                    toast.error(response.data.SvcMsg);
                }
                this.setState({ loader: 'none', opacity: 1 });
            }).catch((e) => {
                this.setState({ loader: 'none', opacity: 1 });
                toast.error('Service failed: ' + e);
            });
    }



    changeCls = (e) => {
        // console.log("changeClass called");
        let wingId = this.state.wingId;
        let screenId = 33;
        var classId = $('#clsCmb').find('option:selected').attr('dataid');
        var className = $('#clsCmb').find('option:selected').text();
        var hpcF = $('#clsCmb').find('option:selected').attr('datahpcformat');
        var hpcV = $('#clsCmb').find('option:selected').attr('datahpcversion');
        // console.log(classId, className, hpcF, hpcV)
        this.setState({
            classId: classId,
            className: className,
            classSectionId:0,
            hpcFormat:hpcF,
            hpcVersion:hpcV
        });
        this.setState({ lstFeeStudent: [] })
        this.setState({ loader: 'block', opacity: 0.5 });
        axios.post(httpURLCommon + '/sms/cls/sec/list',
            queryString.stringify({ classId, screenId }), {
            headers: { 'tokenid': this.state.tokenid },
            withCredentials: true,
        }).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                // console.log("response.data.lstClassSection = ", response.data.lstClassSection);
                this.setState({ lstClassSection: response.data.lstClassSection });
                // console.log("lstClassSection settled");
                {
                    this.state
                        && this.state.lstClassSection
                        && this.state.lstClassSection.length != 0
                        &&
                        // this.getFeeStudentsList(classId, response.data.lstClassSection[0].sectionId);
                        this.setState({
                            classId: classId,
                            classSectionId: response.data.lstClassSection[0].sectionId,
                        });
                    // console.log('after starting classId, classSectionId states update in changeCls');
                }
            } else {
                toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((e) => {
            this.setState({ loader: 'none', opacity: 1 });
            toast.error('Service failed: ' + e);
        });
    }

    handleCallback = (classSectionId, classSectionName) => {
        // console.log("handleCallback called in feestudent.js");
        // console.log("classSectionId passed to handleCallback", classSectionId);
        this.setState({
            classId: this.state.classId,
            classSectionId: classSectionId,
            classSectionName: classSectionName
        });
        // console.log("classSectionId", classSectionId);
        // this.getFeeStudentsList(this.state.classId, classSectionId);
    }
    setStudentName = (pNm) => {
        this.setState({studentName:pNm})
    }
    setImgPath = (pNm) => {
        this.setState({imgPath:pNm})
    }
    openDiscountSlider = (obj) => {
        // console.log("openDiscountSlider called,", obj.lstReportCard);
        $('body').addClass('openSlider1');
        this.setState({
            lstStudentPdf: obj.lstReportCard, basePathStudent: obj.basePathStudent, basePathActivity: obj.basePathActivity, sliderKey: Math.round(Math.random() * 99999)
        });

        // stdId, stdName, pImgPath
    }

    closeSlider = () => {
        $('body').removeClass('openSlider');
        $('body').removeClass('openSlider1');
        this.setState({
            studentId: 0,
            studentName: "",
        })
    }

    getWingId = (wingId) => {
        this.setState({
            wingId: wingId
        }, () => this.getLstClass())
    }

    setLoaderValue = (ldr) => {
        this.setState({ loader: ldr });
    }

    setOpacityValue = (opct) => {
        this.setState({ opacity: opct });
    }
    printHpc = () => {
        // console.log('printHpc() called', this.state.lstStudentId)
        //call svc to get report card json for the lstStudentId
        var lstPdfForStudent = []
        /*  this.state.lstStudentId.forEach(element => {
             student.partA1.studentId = element.studentId;
             lstPdfForStudent.push({...student})
         }); */
        let acdYrId = localStorage.getItem("academicYearId")
        let obj = { acdYrId: acdYrId, clsId: this.state.classId, sectionId: this.state.classSectionId, lstStudentId: this.state.lstStudentId }
        // console.log(obj)
        getHpcListSvc(obj, this.cbHpcData)
    }

    cbHpcData = (data) => {
        let obj = data;
        if (obj.status === 'Success') {
            // console.log(obj)
            this.openDiscountSlider(obj)
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }

    }

    render() {
        httpURL = lstModules['fees'].url + ":" + lstModules['fees'].port;
        httpURLCommon = lstModules['main'].url + ":" + lstModules['main'].port;
        return (
            <div style={{ pointerEvents: this.state.opacity === 1 ? 'auto' : 'none' }}>
                <Header wingFromChild={this.getWingId} />
                <ToastContainer autoClose={3000} hideProgressBar />
                <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader }}>
                    <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
                </div>
                {/* <div className="mainContainer feeHeads"> */}
                <div className="container-fluid" style={{ boxShadow: '0 0 10px 0 #214a75' }}>
                    <div className="col-sm-12" style={{ padding: '10px' }}>
                        <div className="col-sm-2">
                            <select autoComplete="off" id="clsCmb" onChange={() => this.changeCls()} className="form-control">
                                <option dataHpcFormat={0} dataHpcVersion={0} id={0} key={0}>Class</option>
                                {this.state.lstClass.map((cls) => {
                                    return <option  datahpcformat={cls.hpcFormat} datahpcversion={cls.hpcVersion} dataid={cls.classId} key={cls.classId}>{cls.classLabel}</option>
                                })}
                            </select>
                        </div>

                        <div className="col-sm-10">
                            {this.state
                                && this.state.lstClassSection
                                && this.state.lstClassSection.length != 0
                                && <Section
                                    data={this.state.lstClassSection}
                                    selected={this.state.lstClassSection[0].sectionId}
                                    parentCallback={this.handleCallback} />
                            }
                        </div>
                    </div>
                </div>

                <div className="col-sm-12">
                    <div className="col-sm-6 col-centered" style={{ margin: '20px auto ' }}>
                        {this.state.classId
                            &&
                            this.state.lstClassSection
                            &&
                            this.state.classSectionId

                            ?
                            <>
                                <button
                                    type="button"
                                    title="Print HPC"
                                    onClick={() => this.printHpc()}
                                    className="btn btn-warning pull-right"
                                    style={{ marginRight: 32 }}
                                >
                                    Print
                                </button>
                                <HpcStudentTable
                                    hpcFormat={this.state.hpcFormat}
                                    openDiscountSlider={this.openDiscountSlider}
                                    setStudentName={this.setStudentName}
                                    setImgPath={this.setImgPath}
                                    classId={this.state.classId}
                                    classSectionId={this.state.classSectionId}
                                    setLoader={this.setLoaderValue}
                                    setOpacity={this.setOpacityValue}
                                    setLstStudentId={this.setLstStudentId}
                                /> </> : null}

                        {/* </div> */}
                    </div>
                </div>
                <div className="discountSection slider1 fullWidthSlider" style={{ width: "80%" }}>
                    <div className="col-sm-12"  >

                        <HpcStudentSlider
                            key={'st_' + this.state.sliderKey}
                            studentId={this.state.studentId}
                            closeSlider={this.closeSlider}
                            studentName={this.state.studentName}
                            classSectionId={this.state.classSectionId}
                            imgPath={this.state.imgPath}
                            lstStudentPdf={this.state.lstStudentPdf}
                            basePathStudent={this.state.basePathStudent}
                            basePathActivity={this.state.basePathActivity}
                            sliderKey={this.state.sliderKey}
                            cls={this.state.className}
                            clsSection={this.state.classSectionName}
                            hpcFormat={this.state.hpcFormat}
                            hpcVersion={this.state.hpcVersion}
                        />
                    </div>

                </div>
            </div>
        )
    }
}
export default HpcStudent;
